import React from "react";

import SkeltonElement from "./SkeltonElement";

const BoxLoader = ({ style }: any) => {
  const renderLoader = () => {
    return <SkeltonElement style={style} />;
  };
  return <>{renderLoader()}</>;
};

export default BoxLoader;
